import React from "react";
import { Select } from "antd";

import { Icons } from "components/layout";
import { Localize } from "components/service";


const { Option } = Select;

const COMMENTS_FILTER_VALUE = "with_comments";

const StandCommentsFilterField = ({ ...props }) => {
    return (
        <Select
            className="stand-comments-filter-field"
            suffixIcon={ <Icons.Arrow type="filled" /> }
            defaultValue={ null }
            { ...props }
        >
            <Option value={ null }>
                <Localize>FORMS.Select_DefaultValue_All</Localize>
            </Option>
            <Option value={ COMMENTS_FILTER_VALUE }>
                <Localize>STAND.Filter_Params_WithComments</Localize>
            </Option>
        </Select>
    );
}

StandCommentsFilterField.value = COMMENTS_FILTER_VALUE;

export default StandCommentsFilterField;
